var UNIX_SEPARATOR = '/';
var WINDOWS_SEPARATOR_PATTERN = /\\/g;

function normalizePath(path) {
  return path.replace(WINDOWS_SEPARATOR_PATTERN, UNIX_SEPARATOR);
}

module.exports = normalizePath;



//////////////////
// WEBPACK FOOTER
// ./node_modules/clean-css/lib/reader/normalize-path.js
// module id = 740
// module chunks = 0 1